import React from "react";

import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory, useLocation } from "react-router-dom";
import { buildTicketsPath } from "../../utils/ticketNavigation";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    flex: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    zIndex: 10,
  },
  btnBack: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: 10,
    padding: theme.spacing(1),
  }
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const handleBack = () => {
    history.push(buildTicketsPath({ ticketId: undefined, search: location.search }));
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader} elevation={0}>
          <IconButton color="primary" onClick={handleBack} className={classes.btnBack}>
            <ArrowBackIos />
          </IconButton>
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
